import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styles from "./MenuBar.module.css";
import MenuItem from "./MenuItem";
import DropMenu from "../../reusable/DropMenu/DropMenu";
import IconTextButton from "../../reusable/Button/IconTextButton";
import FocusIcon from "../../../assets/focus.svg";
import DustbinIcon from "../../../assets/dustbin.svg";
import RedoIcon from "../../../assets/redo.svg";
import UndoIcon from "../../../assets/undo.svg";
import Modal from "../../reusable/Modal/Modal";
import ShareMenu from "../../reusable/ShareMenu/ShareMenu";
import { updateSlidesMetaData } from "../../../store/actions/updateSlidesMetaData";
import {
	updateSlides,
	updateActiveSlide,
} from "../../../store/actions/updateSlideList";
import {
	updateAutoSave,
	updateLastSaved,
} from "../../../store/actions/updateAutoSave";
import { updateEditorState } from "../../../store/actions/updateEditorState";
import {
	updateBackground,
	updateAnimation,
} from "../../../store/actions/updateDesignMode";
import DeleteMenu from "../../reusable/DeleteMenu/DeleteMenu";
import { useHistory } from "react-router-dom";
import Routes from "../../../routes.json";
import { UndoRedo } from "../../../helpers/undoRedo";
import {
	updateSlide as api_updateSlide,
	addSlide as api_addSlide,
	deleteSlide as api_deleteSlide,
} from "../../../helpers/api";
import menuItems from "./MenuItems.json";

const MenuBar = (props) => {
	let history = useHistory();

	const [state, setState] = useState({
		showModal: false,
		showFileDropMenu: false,
		showEditDropMenu: false,
		showShareMenu: false,
		showDeleteMenu: false,
	});

	useEffect(() => {
		document.addEventListener("keyup", handleShortcuts);
		return () => {
			document.removeEventListener("keyup", handleShortcuts);
		};
	}, []);

	const handleShortcuts = (e) => {
		if (
			(e.key === "z" || e.code === "KeyZ" || e.keyCode === 90) &&
			e.ctrlKey
		) {
			e.preventDefault();
			handleUndo();
		} else if (
			(e.key === "y" || e.code === "KeyY" || e.keyCode === 89) &&
			e.ctrlKey
		) {
			e.preventDefault();
			handleRedo();
		}
	};

	const handleMenuOption = (menuItem) => {
		switch (menuItem) {
			case menuItems.FILE:
				setState({
					...state,
					showEditDropMenu: false,
					showFileDropMenu: !state.showFileDropMenu,
				});
				break;
			case menuItems.EDIT:
				setState({
					...state,
					showEditDropMenu: !state.showEditDropMenu,
					showFileDropMenu: false,
				});
				break;
			case menuItems.BACKGROUND:
				// props.updateEditorState(false);
				// props.updateBackground();
				break;
			case menuItems.ANIMATION:
				// props.updateEditorState(false);
				// props.updateAnimation();
				break;
			case menuItems.PREVIEW:
				props.showPreview();
				break;
			case menuItems.SHARE:
				openShareMenu();
				break;

			default:
				setState({
					...state,
					showEditDropMenu: false,
					showFileDropMenu: false,
				});
				break;
		}
	};

	const openShareMenu = () => {
		setState({
			...state,
			showModal: true,
			showEditDropMenu: false,
			showFileDropMenu: false,
			showShareMenu: true,
			showDeleteMenu: false,
		});
	};

	const openDeleteMenu = () => {
		setState({
			...state,
			showModal: true,
			showEditDropMenu: false,
			showFileDropMenu: false,
			showShareMenu: false,
			showDeleteMenu: true,
		});
	};

	const closeShareMenu = () => {
		setState({
			...state,
			showEditDropMenu: false,
			showFileDropMenu: false,
			showShareMenu: false,
			showDeleteMenu: false,
			showModal: false,
		});
	};
	const closeDeleteMenu = (deleted) => {
		setState({
			...state,
			showEditDropMenu: false,
			showFileDropMenu: false,
			showShareMenu: false,
			showDeleteMenu: false,
			showModal: false,
		});
		if (deleted) history.replace(Routes.Slidespage);
	};

	const addSlide = async (slide, insertIndex) => {
		props.updateAutoSave({ saving: true });
		let slides = props.slideList.slides;
		if (insertIndex === slides.length) {
			slides.push(slide);
		} else if (insertIndex === 0) {
			slides.unshift(slide);
		} else {
			slides.splice(insertIndex, 0, slide);
		}
		props.updateSlides({ slides });
		props.updateActiveSlide({ activeSlide: insertIndex });
		UndoRedo.updateActiveSlide(slide);
		try {
			await api_addSlide(props.slidesMetaData.id, slide, insertIndex);
		} catch (error) {}
		props.updateAutoSave({ saving: false });
		props.updateLastSaved({
			lastSaved: Date.now(),
		});
	};

	const deleteSlide = async (slide) => {
		let slides = props.slideList.slides;
		props.updateAutoSave({ saving: true });
		for (let i = 0; i < slides.length; i++) {
			if (slides[i].id === slide.id) {
				slides.splice(i, 1);
				props.updateSlides({ slides });
				let activeSlide = i > 0 ? i - 1 : 0;
				props.updateActiveSlide({
					activeSlide,
				});
				UndoRedo.updateActiveSlide(slides[activeSlide]);
				try {
					await api_deleteSlide(props.slidesMetaData.id, slide.id);
				} catch (error) {}
				break;
			}
		}
		props.updateAutoSave({ saving: false });
		props.updateLastSaved({
			lastSaved: Date.now(),
		});
	};

	const updateSlide = async (slide) => {
		let slides = props.slideList.slides;
		props.updateAutoSave({ saving: true });
		for (let i = 0; i < slides.length; i++) {
			if (slides[i].id === slide.id) {
				slides[i] = { ...slide };
				props.updateSlides({ slides });
				let activeSlide = i;
				props.updateActiveSlide({
					activeSlide,
				});
				UndoRedo.updateActiveSlide(slides[activeSlide]);
				try {
					await api_updateSlide(props.slidesMetaData.id, slide);
				} catch (error) {}
				props.updateAutoSave({ saving: false });
				props.updateLastSaved({
					lastSaved: Date.now(),
				});
				break;
			}
		}
	};

	const handleUndo = () => {
		let ops = UndoRedo.undo();
		if (ops) {
			switch (ops.action) {
				case UndoRedo.slideOps.addSlide:
					addSlide(ops.slide, ops.index);
					break;
				case UndoRedo.slideOps.deleteSlide:
					deleteSlide(ops.slide);
					break;
				case UndoRedo.slideOps.updateSlide:
					updateSlide(ops.slide);
					break;
				default:
					break;
			}
		}
		handleMenuOption();
	};

	const handleRedo = () => {
		let ops = UndoRedo.redo();
		if (ops) {
			switch (ops.action) {
				case UndoRedo.slideOps.addSlide:
					addSlide(ops.slide, ops.index);
					break;
				case UndoRedo.slideOps.deleteSlide:
					deleteSlide(ops.slide);
					break;
				case UndoRedo.slideOps.updateSlide:
					updateSlide(ops.slide);
					break;
				default:
					break;
			}
		}
		handleMenuOption();
	};

	const handleView = () => {
		const win = window.open(
			Routes.ViewPage + "/" + props.slidesMetaData.id,
			"_blank"
		);
		win.focus();
		handleMenuOption();
	};

	const fileDropMenu = (menuItem) => (
		<DropMenu position="bottom" onClose={() => handleMenuOption(menuItem)}>
			<IconTextButton text="View" icon={FocusIcon} action={handleView} />
			<IconTextButton
				text="Delete"
				icon={DustbinIcon}
				action={openDeleteMenu}
			/>
		</DropMenu>
	);

	const editDropMenu = (menuItem) => (
		<DropMenu position="bottom" onClose={() => handleMenuOption(menuItem)}>
			<IconTextButton text="Undo" icon={UndoIcon} action={handleUndo} />
			<IconTextButton text="Redo" icon={RedoIcon} action={handleRedo} />
		</DropMenu>
	);

	const menuToShow = () => {
		if (state.showShareMenu) {
			return (
				<ShareMenu
					data={props.slidesMetaData}
					closeShareMenu={closeShareMenu}
				/>
			);
		} else if (state.showDeleteMenu) {
			return (
				<DeleteMenu
					id={props.slidesMetaData.id}
					closeDeleteMenu={closeDeleteMenu}
				/>
			);
		} else return null;
	};

	return (
		<>
			{state.showModal ? <Modal>{menuToShow()}</Modal> : null}
			<div className={styles.menuBar}>
				<div className={styles.menuItem}>
					<div onClick={() => handleMenuOption(menuItems.FILE)}>
						<MenuItem text={menuItems.FILE} />
					</div>
					{state.showFileDropMenu
						? fileDropMenu(menuItems.FILE)
						: null}
				</div>
				<div className={styles.menuItem}>
					<div onClick={() => handleMenuOption(menuItems.EDIT)}>
						<MenuItem text={menuItems.EDIT} />
					</div>
					{state.showEditDropMenu
						? editDropMenu(menuItems.EDIT)
						: null}
				</div>
				{/* <div className={styles.menuItem}>
					<div onClick={() => handleMenuOption(menuItems.BACKGROUND)}>
						<MenuItem text={menuItems.BACKGROUND} />
					</div>
				</div>
				<div className={styles.menuItem} style={{ display: "none" }}>
					<div onClick={() => handleMenuOption(menuItems.ANIMATION)}>
						<MenuItem text={menuItems.ANIMATION} />
					</div>
				</div> */}
				<div className={styles.menuItem}>
					<div onClick={() => handleMenuOption(menuItems.SHARE)}>
						<MenuItem text={menuItems.SHARE} active={false} />
					</div>
				</div>
				<div className={styles.menuItem}>
					<div onClick={() => handleMenuOption(menuItems.PREVIEW)}>
						<MenuItem text={menuItems.PREVIEW} active={true} />
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	...state,
});
const mapDispatchToProps = (dispatch) => ({
	updateSlidesMetaData: (payload) => dispatch(updateSlidesMetaData(payload)),
	updateSlides: (payload) => dispatch(updateSlides(payload)),
	updateActiveSlide: (payload) => dispatch(updateActiveSlide(payload)),
	updateAutoSave: (payload) => dispatch(updateAutoSave(payload)),
	updateLastSaved: (payload) => dispatch(updateLastSaved(payload)),
	updateEditorState: (payload) => dispatch(updateEditorState(payload)),
	updateBackground: (payload) => dispatch(updateBackground(payload)),
	updateAnimation: (payload) => dispatch(updateAnimation(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuBar);
